/**
 * @author mi
 * @date 2018/12/5
 * @project kaoshizhongxin
 */
/* 大写数字 */
export const NUMERALS = ['一', '二', '三', '四', '五', '六', '七', '八', '九', '十']
// 性别
export const MALE = [
  {
    id: 1,
    text: '男'
  },
  {
    id: 2,
    text: '女'
  }
]
// 年级
export const GRADES = [
  {
    id: 4,
    text: '高一'
  },
  {
    id: 5,
    text: '高二'
  },
  {
    id: 6,
    text: '高三'
  },
  {
    id: 1,
    text: '初一'
  },
  {
    id: 2,
    text: '初二'
  },
  {
    id: 3,
    text: '初三'
  }
]

// 学科
export const SUBJECT = [
  {
    'subjectID': '12',
    'subjectName': '语文'
  },
  {
    'subjectID': '13',
    'subjectName': '数学'
  },
  {
    'subjectID': '14',
    'subjectName': '英语'
  },
  {
    'subjectID': '15',
    'subjectName': '物理'
  },
  {
    'subjectID': '16',
    'subjectName': '化学'
  },
  {
    'subjectID': '17',
    'subjectName': '生物'
  },
  {
    'subjectID': '18',
    'subjectName': '政治'
  },
  {
    'subjectID': '19',
    'subjectName': '历史'
  },
  {
    'subjectID': '20',
    'subjectName': '地理'
  }
]
